import { AppAPI, } from '@moderepo/mode-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var AlertingActionType;
(function (AlertingActionType) {
    AlertingActionType["SET_ALERT_RULE"] = "set alert rule";
    AlertingActionType["SET_ALERT_RULES"] = "set alert rules";
    AlertingActionType["CLEAR_ALERT_RULES"] = "clear alert rules";
    AlertingActionType["SET_ALERT"] = "set alert";
    AlertingActionType["SET_ALERTS"] = "set alerts";
    AlertingActionType["CLEAR_ALERTS"] = "clear alerts";
})(AlertingActionType || (AlertingActionType = {}));
export const setAlertRules = (projectId, alertRules, searchParams) => {
    return {
        type: AlertingActionType.SET_ALERT_RULES,
        projectId,
        alertRules,
        searchParams,
    };
};
export const setAlertRule = (projectId, alertRule) => {
    return {
        type: AlertingActionType.SET_ALERT_RULE,
        projectId,
        alertRule,
    };
};
export const clearAlertRules = (projectId) => {
    return {
        type: AlertingActionType.CLEAR_ALERT_RULES,
        projectId,
    };
};
export const setAlerts = (projectId, alerts, searchParams) => {
    return {
        type: AlertingActionType.SET_ALERTS,
        projectId,
        alerts,
        searchParams,
    };
};
export const setAlert = (projectId, alert) => {
    return {
        type: AlertingActionType.SET_ALERT,
        projectId,
        alert,
    };
};
export const clearAlerts = (projectId) => {
    return {
        type: AlertingActionType.CLEAR_ALERTS,
        projectId,
    };
};
/**
 * Get multiple alert rules belonged to a Project
 * @param projectId - The id of the project to look for
 */
export const fetchAlertRules = (projectId, filters) => {
    return async (dataDispatch) => {
        const modifiedFilters = {
            ...filters,
            // change pageSize/pageNumber to skip/limit
            skip: (filters === null || filters === void 0 ? void 0 : filters.pageNumber) !== undefined && (filters === null || filters === void 0 ? void 0 : filters.pageSize) !== undefined ? filters.pageNumber * filters.pageSize : undefined,
            limit: (filters === null || filters === void 0 ? void 0 : filters.pageSize) !== undefined ? filters.pageSize : undefined,
            // exclude pageSize/pageNumber
            pageNumber: undefined,
            pageSize: undefined,
        };
        const alertRules = await AppAPI.getInstance().getAlertRules(projectId, modifiedFilters);
        await dataDispatch(setAlertRules(projectId, alertRules, searchParamsToString(filters)));
    };
};
/**
 * Get an alert rule by id. This action will also update the app state.
 *
 * @param alertRuleId - The ID of the alert rule we want to get
 */
export const fetchAlertRuleById = (projectId, alertRuleId) => {
    return async (dataDispatch) => {
        const alertRule = await AppAPI.getInstance().getAlertRuleById(alertRuleId);
        await dataDispatch(setAlertRule(projectId, alertRule));
    };
};
/**
 * Create an alert rule.
 * @param projectId - The id of the project the alert rule belonged to
 * @param params - The attributes and their values to be updated
 */
export const createAlertRule = (projectId, params) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().createAlertRule(params);
        // Need to clear the alert rules because the list of alert rules changed
        await dataDispatch(clearAlertRules(projectId));
    };
};
/**
 * Update an alert rule.
 * @param projectId - The id of the project the alert rule belonged to
 * @param alertRuleId - The id of the alert rule which we want to update
 * @param params - The attributes and their values to be updated
 */
export const updateAlertRule = (projectId, alertRuleId, params) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().updateAlertRule(alertRuleId, params);
        // Need to clear the alert rules because updating the alert rule's attributes can cause the list of alert rules to be changed
        await dataDispatch(clearAlertRules(projectId));
    };
};
/**
 * Delete an alert rule.
 * @param projectId - The id of the project the alert rule belonged to
 * @param alertRuleId - The id of the alert rule which we want to update
 * @param params - The attributes and their values to be updated
 */
export const deleteAlertRule = (projectId, alertRuleId) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().deleteAlertRule(alertRuleId);
        // Need to clear the alert rules because the list of alert rules changed
        await dataDispatch(clearAlertRules(projectId));
    };
};
/**
 * Get multiple alert belonged to a Project
 * @param projectId - The id of the project to look for
 */
export const fetchAlerts = (projectId, filters) => {
    return async (dataDispatch) => {
        const modifiedFilters = {
            ...filters,
            // change pageSize/pageNumber to skip/limit
            skip: (filters === null || filters === void 0 ? void 0 : filters.pageNumber) !== undefined && (filters === null || filters === void 0 ? void 0 : filters.pageSize) !== undefined ? filters.pageNumber * filters.pageSize : undefined,
            limit: (filters === null || filters === void 0 ? void 0 : filters.pageSize) !== undefined ? filters.pageSize : undefined,
            // exclude pageSize/pageNumber
            pageNumber: undefined,
            pageSize: undefined,
        };
        const alerts = await AppAPI.getInstance().getAlerts(projectId, modifiedFilters);
        await dataDispatch(setAlerts(projectId, alerts, searchParamsToString(filters)));
    };
};
/**
 * Get an alert rule by id. This action will also update the app state.
 *
 * @param alertId - The ID of the alert rule we want to get
 */
export const fetchAlertById = (projectId, alertId) => {
    return async (dataDispatch) => {
        const alert = await AppAPI.getInstance().getAlertById(alertId);
        await dataDispatch(setAlert(projectId, alert));
    };
};
